export const SITE_FLOW_BASE_URL = 'https://siteflow.merch.vpsvc.com/v2';

export const requestor = 'collaborate-ui';

export const WORK_ENTITY_SERVICE_BASE_URL = 'https://workentityservice.design.vpsvc.com/api/v1';
